<template>
  <v-app>
    <router-view />
    <!-- <NoticeDialog></NoticeDialog> -->
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import io from "socket.io-client";
// import NoticeDialog from '@/components/Notice/NoticeDialog.vue'

export default {
  name: "App",
  components: {
    // NoticeDialog
  },

  data() {
    return {
      socket: null,
      socketioURL: `${process.env.VUE_APP_BACKEND}`,
      pageBefore: null,
      pageAfter: null,
      position_id: localStorage.getItem("position_id"),
    };
  },
  async mounted() {
    // this.onNotice()
    if (this.account_id != null && this.business_id != null) {
      this.socket = io(this.socketioURL, {
        transports: ["websocket", "polling"],
        path: "/websocket",
      });
      // this.socket.on("connect_socket_io", (data) => {
      //   console.log(data);
      //   this.getAlertCount()
      // });

      this.socket.on("new_notification", (response) => {
        const socketList = response.data;
        const socketShow = socketList.find((data) => {
          return (
            data.noti_to_acc_id === this.account_id &&
            data.noti_to_biz_id === this.business_id
          );
        });
        if (typeof socketShow === "object") {
          this.getAlertCount();
        }
      });
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.getAlert();
      },
    },
    pageAfter(val, oldVal) {
      if (val != oldVal) {
        if (this.account_id != null && this.business_id != null) {
          this.getAlertCount();
        }
      }
    },
    biz_recruit_id(val, oldVal) {
      if (val != oldVal) {
        this.getAlertCount();
      }
    },
    business_id(val, oldVal) {
      if (val != oldVal) {
        this.getAlertCount();
      }
    },
  },
  computed: {
    ...mapGetters({
      business_id: "business_id",
      account_id: "account_id",
      biz_recruit_id: "biz_recruit_id",
    }),
  },
  methods: {
    getAlert() {
      if (!this.account_id || !this.business_id) return;
      this.getAlertCount();
    },
    async getAlertCount() {
      await this.$store
        .dispatch("getAlertCount", {
          account_id: this.account_id,
          business_id: this.business_id,
          role_id: this.position_id,
        })
        .catch((err) =>
          this.$store.commit("onAlerting", {
            message_status: err.message,
            color: "#D1392B",
          })
        );
    },
    onNotice() {
      this.$store.commit("onNoticeDialog");
    },
  },
  beforeDestroy() {
    // For a specific event
    this.socket.removeAllListeners(["connect_socket_io"]);
    // For all events
    this.socket.removeAllListeners();
    // Disconnect socket
    this.socket.disconnect();
  },
};
</script>
<style>
/* .tox-tinymce-aux {
  display: none !important;
} */
</style>
